import oc from "open-color";
import React, { ReactElement } from "react";
import { MemoizedValue } from "../../../helpers/memoizer";
import c from "./MultiValuesDisplay.module.css";
import { STALE_COLOR } from ".";

export default function MultiValuesDisplay({
  name,
  color,
  values,
  inRow,
}: {
  name: string;
  color?: string;
  values: {
    label?: string;
    value: MemoizedValue;
    unit: string;
  }[];
  inRow?: boolean;
}): ReactElement {
  const allStale = values.every((v) => v.value.isStale);
  const valueNodes = values.map(({ label, value, unit }, i) => (
    <div key={i} style={{ color: value.isStale ? STALE_COLOR : color || oc.black }}>
      {label && <span>{label}</span>}
      <span className={c.value}>{value.displayValue || "-"}</span>
      <span className="unit">{unit}</span>
    </div>
  ));
  return (
    <div
      style={{
        margin: "0 auto",
        borderRadius: "5px",
        border: `2px solid ${allStale ? STALE_COLOR : color || oc.gray[7]}`,
        padding: "5px 10px",
        flexGrow: 1,
      }}
    >
      <div
        style={{
          color: allStale ? STALE_COLOR : oc.black,
          fontSize: "12px",
          marginBottom: "5px",
        }}
      >
        {name}
      </div>
      <div className={inRow ? "d-flex justify-content-between" : ""} style={{ flexWrap: "wrap" }}>
        {valueNodes}
      </div>
    </div>
  );
}
